module.exports = __webpack_public_path__ + "img/icon_wechat_code.1fccc4df.jpg";